<button id="close-button" (click)="onClose()" trackable="Edit delivery/Change address/close">
  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
    <path d="M7 7L1 1M7 1L1 7" stroke="#7A89AD" stroke-width="2" stroke-linecap="round" />
  </svg>
</button>
<ng-container *ngIf="!showChangeTimeMenu">
  <main>
    <common-map
      #mapComponent
      [fitBoundsToAllMarkers]="true"
      [mapMarkers]="[dropoffMarker!]"
      [boundsPadding]="defaultMapBoundsPadding"
      class="edit-map"></common-map>
    <form [formGroup]="form" (ngSubmit)="submitNewDropoff()" id="form">
      <div>
        <label id="address-label">Select a new delivery address</label>
        <common-change-address-search-input
          [class.error]="showAddressError"
          (emitInvalidAddress)="showAddressError = true"
          [addressSelected]="addressSelected"
          [orderDetails]="order"
          (validAddressSelected)="onAddressSelected($event)"
          [formControlExternalName]="'address'"></common-change-address-search-input>
      </div>

      <div *ngIf="showAddressError" class="error-note">This address is not eligible for delivery.</div>

      <div *ngIf="addressSelected">
        <label id="address2-label">Address line 2 <span class="optional">(optional)</span></label>
        <input
          class="e-input"
          placeholder="Apartment, floor, any other information"
          [formControlName]="'addressLine2'"
          trackable="Edit delivery/address line 2" />
      </div>
    </form>
  </main>
  <div class="button-container" *ngIf="!showChangeTimeMenu">
    <button
      type="submit"
      id="submit-button"
      form="form"
      [style.color]="textColor"
      [style.background-color]="brandColor"
      [disabled]="!addressSelected || loading">
      Confirm new drop-off
      <img *ngIf="loading" src="../assets/loading-circle-white-animated.svg" />
    </button>
  </div>
</ng-container>
<common-edit-order-change-date-time
  *ngIf="showChangeTimeMenu && orderWithNewDestination"
  [order]="orderWithNewDestination"
  [externalProposals]="lastQuoteResponse?.dateProposals"
  [brandColor]="brandColor"
  (emitCancel)="closeTimeMenu()"
  [textColor]="textColor"
  [displayCancelButton]="true"
  [subTitle]="'Select a new delivery time:'"
  [note]="changeTimeNote"></common-edit-order-change-date-time>

<common-edit-order-contact-us-button
  [brandColor]="brandColor"
  [trackableText]="'Change address'"></common-edit-order-contact-us-button>

<div class="confirmation-modal" *ngIf="showConfirmationModal">
  <div class="modal-box">
    <div class="title">Are you sure you want to exit without saving the new delivery address?</div>
    <div class="buttons" [style.--brandColor]="brandColor">
      <button
        type="button"
        class="button confirm"
        (click)="onConfirmClose()"
        [style.background-color]="brandColor"
        trackable="Edit delivery/Exit without saving new address/Yes, keep previous address">
        Yes, keep previous address
      </button>
      <button
        type="button"
        class="button cancel"
        (click)="onCancelClose()"
        [style.color]="brandColor"
        [style.border-color]="brandColor"
        trackable="Edit delivery/Exit without saving new address/No, go back">
        {{ showChangeTimeMenu ? 'Go back to time selection' : 'Confirm new address' }}
      </button>
    </div>
  </div>
</div>
